var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4613 10.4062V6.6875C18.4613 6.1007 17.9794 5.625 17.3851 5.625L5.5469 5.625C4.95253 5.625 4.4707 6.1007 4.4707 6.6875L4.4707 17.3125C4.4707 17.8993 4.95253 18.375 5.5469 18.375L17.3851 18.375C17.9794 18.375 18.4613 17.8993 18.4613 17.3125V13.5937M19.4629 9.875H14.1565C12.9677 9.875 12.0041 10.8264 12.0041 12C12.0041 13.1736 12.9677 14.125 14.1565 14.125H19.4629C19.5041 14.125 19.5374 14.092 19.5374 14.0514V9.94864C19.5374 9.90797 19.5041 9.875 19.4629 9.875Z",
    stroke: "#333333",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankNewIcon);
export default __webpack_public_path__ + "static/media/BankNewIcon.f5820b2a206cdfbeeec7b55f2360babc.svg";
export { ForwardRef as ReactComponent };